import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { FormsModule } from '@angular/forms';
import { NumericUpDownComponent } from 'src/app/ui/molecules/numeric-up-down/numeric-up-down.component';

@Component({
  selector: 'app-step2',
  standalone: true,
  imports: [
    TranslatePipe,
    FormsModule,
    NumericUpDownComponent
  ],
  templateUrl: './step2.component.html',
  styleUrl: './step2.component.scss'
})
export class Step2Component {
  @Input({required: true}) quotation: Quotation;
}
